import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

// Live promo + list-price settings from Admin → Promotions (cached per page load).
let cache = null;
let inflight = null;
const load = () => {
  if (!inflight) inflight = api.get("/promo/status").then((r) => { cache = r.data; return r.data; }).catch(() => null);
  return inflight;
};
export const refreshPromoStatus = () => { inflight = null; return load(); };

export function money(n, lang = "en") {
  const v = Math.round(Number(n || 0) * 100) / 100;
  const s = v.toLocaleString(lang === "fr" ? "fr-FR" : "en-US", { maximumFractionDigits: v % 1 ? 2 : 0 });
  return lang === "fr" ? `${s.replace(/\u202f/g, "\u00a0")}\u00a0$` : `$${s}`;
}

export default function usePromoStatus() {
  const { i18n } = useTranslation();
  const [promo, setPromo] = useState(cache);
  useEffect(() => { let on = true; load().then((d) => on && d && setPromo(d)); return () => { on = false; }; }, []);
  const lang = (i18n.language || "en").slice(0, 2);
  const lp = promo?.list_prices || { basic: 750, premium: 1250 };
  const loyalty = promo?.loyalty || { active: true, price: 750 };
  const referral = promo?.referral || { active: true, required: 3, percent: 20 };
  const freeCap = promo?.free_cap ?? 30;
  const halfCap = promo?.half_cap ?? 10;
  const half = promo?.half_price ?? 375;
  const loyaltyOn = !!loyalty.active && loyalty.price < lp.premium;
  const referralOn = !!referral.active && referral.percent > 0;
  const upgradeAmt = loyaltyOn ? loyalty.price : lp.premium;
  const finalAmt = Math.round(upgradeAmt * (1 - referral.percent / 100) * 100) / 100;
  const m = (n) => money(n, lang);
  const params = {
    basic: m(lp.basic), premium: m(lp.premium), loyalty: m(loyalty.price), upgrade: m(upgradeAmt),
    save: m(lp.premium - loyalty.price), pct: referral.percent, n: referral.required, final: m(finalAmt),
    freeCap, from: freeCap + 1, to: freeCap + halfCap, half: m(half),
    halfPct: lp.basic ? Math.round(100 * (1 - half / lp.basic)) : 0,
    was: m(promo?.premium_anchor?.was_price ?? 1500),
  };
  return { promo, loaded: !!promo, lp, loyalty, referral, loyaltyOn, referralOn, upgradeAmt, finalAmt, params, m };
}
